<script setup>
import { ref } from "vue";
import { Field, ErrorMessage, useForm } from "vee-validate";
import * as yup from "yup";
import { defineEmits } from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faEye, faEyeSlash);
const showPassword = ref(false);
const emit = defineEmits(["submit"]);
const validationSchema = yup.object({
  email: yup
    .string()
    .email("Correo electrónico inválido")
    .required("El correo electrónico es obligatorio"),
  password: yup.string().required("La contraseña es obligatoria"),
});
const { handleSubmit: validateAndSubmit } = useForm({
  validationSchema,
});
const onSubmit = (values) => {
  emit("submit", values);
};
const handleSubmit = validateAndSubmit(onSubmit);
const togglePassword = () => {
  showPassword.value = !showPassword.value;
};
</script>
<template>
  <form @submit="handleSubmit" class="max-w-md mx-auto space-y-6">
    <Field
      name="email"
      type="email"
      class="w-full px-4 py-3 border rounded-lg bg-white text-black placeholder-gray-500 focus:ring-2 focus:ring-[#99b642]"
      placeholder="Ingresa tu correo electrónico"
    />
    <ErrorMessage name="email" class="text-white text-sm" />
    <div class="relative">
      <Field
        name="password"
        :type="showPassword ? 'text' : 'password'"
        class="w-full px-4 py-3 border rounded-lg bg-white text-black placeholder-gray-500 focus:ring-2 focus:ring-[#99b642]"
        placeholder="Contraseña"
      />
      <button
        type="button"
        @click="togglePassword"
        class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
      >
        <font-awesome-icon :icon="showPassword ? 'eye-slash' : 'eye'" />
      </button>
    </div>
    <ErrorMessage name="password" class="text-white text-sm" />
    <button
      type="submit"
      class="w-full py-3 bg-white text-black font-semibold rounded-lg shadow-md hover:bg-gray-200 focus:ring-4 focus:ring-[#99b642] focus:ring-opacity-50 transition-all"
    >
      Iniciar sesión
    </button>
  </form>
</template>
<style scoped>
form {
  animation: fadeIn 0.5s ease-out;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
